export default __webpack_public_path__ + "static/media/P943_CoC.b87ea23d.pdf";